// Основной layout: Header + Sidebar + Content (Outlet).
// Используется как обёртка под ProtectedRoute.
//
// GlobalErrorListener рендерится здесь, потому что он использует
// useCrossTabLogout → useNavigate, которые требуют Router-контекста.
// В App.tsx он не может быть выше RouterProvider (там useNavigate ломается
// с «useNavigate() may be used only in the context of a <Router> component»).
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { AppHeader } from "./Header";
import { AppSidebar } from "./Sidebar";
import { GlobalErrorListener } from "../GlobalErrorListener";
import type { MeResponse } from "@/api/types";

interface Props {
  me: MeResponse;
}

export function AppLayout({ me }: Props) {
  // Layout зафиксирован в окне (height: 100vh), скроллится только Content.
  // Так Sider всегда занимает всю видимую высоту → AntD collapse-trigger
  // остаётся прижатым к нижней границе видимого окна и не уплывает за
  // пределы при скролле основного контента. Header тоже остаётся на месте.
  // minHeight: 0 на внутреннем Layout важен для flexbox-overflow: без него
  // Content игнорирует overflow:auto.
  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <GlobalErrorListener />
      <AppHeader me={me} />
      <Layout style={{ minHeight: 0 }}>
        <AppSidebar me={me} />
        <Layout.Content style={{ padding: 24, overflow: "auto" }}>
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  );
}
